// extracted by mini-css-extract-plugin
export default {"form":"UserForm_form__kh60L","button":"UserForm_button__Ejsz4","formGroup":"UserForm_formGroup__VZQdW"};